<mt-card
    class="swag-paypal-settings-express"
    position-identifier="swag-paypal-settings-express"
    :title="$t('swag-paypal-settings.express.title')"
    :subtitle="$t('swag-paypal-settings.express.subtitle')"
    :is-loading="settingsStore.isLoading"
>
    <mt-banner v-if="doubleOptInConfig" variant="attention">
        {{ $t('swag-paypal-settings.express.alertMessage') }}
    </mt-banner>
    <mt-banner v-if="phoneRequiredConfig" variant="attention">
        <i18n-t keypath="swag-paypal-settings.express.alertMessagePhone" tag="p">
            <template #url>
                <a href="https://www.paypal.com/businessmanage/preferences/website" target="_blank">{{ $t('swag-paypal-settings.express.alertMessagePhoneLink') }}</a>
            </template>
        </i18n-t>
    </mt-banner>

    <swag-paypal-setting path="SwagPayPal.settings.ecsDetailEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsCartEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsOffCanvasEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsLoginEnabled" />
    <swag-paypal-setting path="SwagPayPal.settings.ecsListingEnabled" />

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsButtonColor"
        :options="buttonColorOptions"
        :disabled="ecsSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsButtonShape"
        :options="buttonShapeOptions"
        :disabled="ecsSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsButtonLanguageIso"
        :disabled="ecsSettingsDisabled"
    >
        <template #content="props">
            <swag-paypal-settings-locale-select
                :name="props.path"
                :disabled="props.disabled"
                :value="props.currentValue"
                @update:value="props.updateCurrentValue"
            />
        </template>
    </swag-paypal-setting>

    <swag-paypal-setting
        path="SwagPayPal.settings.ecsShowPayLater"
        :disabled="ecsSettingsDisabled"
    />

    <swag-paypal-setting
        v-tooltip="ecsShippingCallbackSettingTooltip"
        path="SwagPayPal.settings.ecsShippingCallbackEnabled"
        :disabled="ecsShippingCallbackSettingDisabled"
    />
</mt-card>

<mt-card
    class="swag-paypal-settings-installment"
    position-identifier="swag-paypal-settings-installment"
    :title="$t('swag-paypal-settings.installment.title')"
    :subtitle="$t('swag-paypal-settings.installment.subtitle')"
    :is-loading="settingsStore.isLoading"
>
    <div class="swag-paypal-settings-installment__layout">
        <div class="swag-paypal-settings-installment__left">
            <div class="swag-paypal-settings-installment__appearance">
                <mt-text
                    as="span"
                    weight="semibold"
                    size="s"
                    color="color-text-primary-default"
                    class="swag-paypal-settings-installment__section-title"
                >
                    {{ $t('swag-paypal-settings.installment.appearance') }}
                </mt-text>

                <swag-paypal-setting
                    path="SwagPayPal.settings.installmentBannerLogoType"
                    :options="bannerLogoTypeOptions"
                />

                <swag-paypal-setting
                    path="SwagPayPal.settings.installmentBannerTextColor"
                    :options="bannerTextColorOptions"
                />

                <swag-paypal-setting
                    path="SwagPayPal.settings.installmentBannerTextSize"
                    :options="bannerTextSizeOptions"
                />
            </div>

            <div class="swag-paypal-settings-installment__visibility">
                <mt-text
                    as="span"
                    weight="semibold"
                    size="s"
                    color="color-text-primary-default"
                    class="swag-paypal-settings-installment__section-title"
                >
                    {{ $t('swag-paypal-settings.installment.pageVisibility') }}
                </mt-text>

                <mt-text
                    as="span"
                    size="xs"
                    color="color-text-secondary-default"
                    class="swag-paypal-settings-installment__section-subtitle"
                >
                    {{ $t('swag-paypal-settings.installment.pageVisibilitySubtitle') }}
                </mt-text>

                <swag-paypal-setting path="SwagPayPal.settings.installmentBannerDetailPageEnabled" />
                <swag-paypal-setting path="SwagPayPal.settings.installmentBannerCartEnabled" />
                <swag-paypal-setting path="SwagPayPal.settings.installmentBannerOffCanvasCartEnabled" />
                <swag-paypal-setting path="SwagPayPal.settings.installmentBannerLoginPageEnabled" />
                <swag-paypal-setting path="SwagPayPal.settings.installmentBannerFooterEnabled" />
            </div>
        </div>

        <div class="swag-paypal-settings-installment__right">
            <mt-text
                as="span"
                weight="semibold"
                size="s"
                color="color-text-primary-default"
                class="swag-paypal-settings-installment__section-title"
            >
                {{ $t('swag-paypal-settings.installment.preview') }}
            </mt-text>

            <swag-paypal-settings-banner-preview />
        </div>
    </div>
</mt-card>

<mt-card
    class="swag-paypal-settings-spb"
    position-identifier="swag-paypal-settings-spb"
    :is-loading="settingsStore.isLoading"
>
    <template #title>
        <swag-paypal-setting
            :bordered="false"
            :label="$t('swag-paypal-settings.spb.title')"
            path="SwagPayPal.settings.spbCheckoutEnabled"
            class="sw-card__title"
        />
    </template>

    <swag-paypal-setting
        path="SwagPayPal.settings.spbAlternativePaymentMethodsEnabled"
        :disabled="sbpSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbShowPayLater"
        :disabled="sbpSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbAppSwitchEnabled"
        :disabled="sbpSettingsDisabled"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbButtonColor"
        :disabled="sbpSettingsDisabled"
        :options="buttonColorOptions"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbButtonShape"
        :disabled="sbpSettingsDisabled"
        :options="buttonShapeOptions"
    />

    <swag-paypal-setting
        path="SwagPayPal.settings.spbButtonLanguageIso"
        :disabled="sbpSettingsDisabled"
    >
        <template #content="props">
            <swag-paypal-settings-locale-select
                :name="props.path"
                :disabled="props.disabled"
                :value="props.currentValue"
                @update:value="props.updateCurrentValue"
            />
        </template>
    </swag-paypal-setting>
</mt-card>
